import TopSymbol from "features/watchlist/TopSymbols/TopSymbol";
import { AnimatePresence, motion } from "motion/react";
import React, { useMemo } from "react";
import { watchlistService } from "app/services/watchlist.service";
import { getTextWidth } from "common/Text/utils.ts";
import {
  SYMBOL_FONT_SIZE,
  SYMBOL_FONT_WEIGHT,
  SYMBOL_HORIZONTAL_MARGIN,
  SYMBOL_ICON_MARGIN,
  SYMBOL_ICON_SIZE,
} from "features/watchlist/TopSymbols/constants.ts";

interface TopSymbolsListProps {
  maxWidth: number;
}

const TopSymbolsList = ({ maxWidth }: TopSymbolsListProps) => {
  let { data: topSymbolsList } = watchlistService.useGetWatchlistQuery();

  const longestSymbol = useMemo(() => {
    return topSymbolsList?.sortedWatchlist
      .slice(0, MAX_NUM_OF_SYMBOLS)
      .sort((a, b) => b.symbol.length - a.symbol.length)[0]?.symbol;
  }, [topSymbolsList]);

  const symbolMaxWidth = useMemo(() => {
    const textWidth = getTextWidth(
      longestSymbol,
      SYMBOL_FONT_SIZE,
      SYMBOL_FONT_WEIGHT
    );
    return (
      textWidth +
      SYMBOL_ICON_SIZE +
      SYMBOL_ICON_MARGIN +
      2 * SYMBOL_HORIZONTAL_MARGIN
    );
  }, [longestSymbol]);

  const symbolCount = useMemo(() => {
    return Math.min(Math.floor(maxWidth / symbolMaxWidth), MAX_NUM_OF_SYMBOLS);
  }, [maxWidth, symbolMaxWidth]);

  return (
    <div style={{ display: "flex" }}>
      {/*@ts-ignore*/}
      <AnimatePresence>
        {topSymbolsList?.sortedWatchlist
          .slice(0, symbolCount)
          .map((market, i) => (
            <motion.div
              key={`${market.exchange}_${market.symbol}`}
              custom={i}
              layout
              initial="hidden"
              animate="visible"
              variants={variants}
            >
              <TopSymbol key={i} market={market} />
            </motion.div>
          ))}
      </AnimatePresence>
    </div>
  );
};

export default TopSymbolsList;

const MAX_NUM_OF_SYMBOLS = 5;

const variants = {
  visible: {
    opacity: 1,
    transition: { ease: "easeIn", duration: 0.3 },
  },
  hidden: { opacity: 0 },
};
